import { useMemo } from "react";

const dateTimeFormat = new Intl.DateTimeFormat("en", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
});

export const useFormatDetailsDate = (date: Date | null): string =>
    useMemo(() => {
        if (date === null) {
            return "N/A";
        }
        return dateTimeFormat.format(date);
    }, [date]);
